const getters = {
  getNumberNotification: state => state.numberNotification,
  getListNotifications: state => state.listNotifications,
  getTotalNotifications: state => state.totalNotifications
}

export default getters
